/**
 * 5.0.8.3 Profile - Enterprise Admin - Group Portal
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3631%3A19753
 */
// @react
import React from 'react'
// @design
import { makeStyles } from '@material-ui/core/styles'
// @components
// @module Components

const useStyles = makeStyles({
  root: {},
})

const GroupPortal = () => {
  /******************************************
   * HOOKS
   ******************************************/
  const classes = useStyles()

  /******************************************
   * FUNCTIONS
   ******************************************/

  /**
   * props
   */
  return <div className={classes.root}>Group portal tab content</div>
}

export default GroupPortal
